module.exports = __webpack_public_path__ + "img/phonekaka1.03d2d64a.png";